import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import { loadCategoryData } from "@/api/api";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import PhotoCard from "@/components/common/PhotoCard";
// import JCategorySelect from "@comp/jeecg/JCategorySelect";
import { filterMultiDictText } from "@comp/jeecg/JDictSelectUtil";
import "@/assets/less/animation.css";
export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag: JDictSelectTag,
    PhotoCard: PhotoCard
    // JCategorySelect,
  },
  data: function data() {
    return {
      dataSource: [],
      pagination: {
        onChange: function onChange(page) {
          console.log(page);
        },
        pageSize: this._isMobile() ? 8 : 12
      },
      loading: true,
      productType: "",
      tenantConfig: {},
      videoVisible: false,
      currentItem: {},
      queryParam: {
        pageSize: 999
      },
      dictOptions: {}
    };
  },
  created: function created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (this.$route.query.type) {
      this.queryParam.eventType = this.$route.query.type;
    }
    this.getList();
    // loadCategoryData({ code: "A05" }).then((res) => {
    //   if (res.success) {
    //     this.$set(this.dictOptions, "eventCategory", res.result);
    //   }
    // });
  },
  mounted: function mounted() {},
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      this.dataSource = [];
      getAction("/teaching/teachingEvent/getAvailableEvent", this.queryParam).then(function (res) {
        console.log(res);
        if (res.success) {
          _this.dataSource = res.result.records;
        }
        _this.loading = false;
      });
    },
    isBigCover: function isBigCover(record) {
      if (record.showConfig) {
        console.log(record.showConfig);
        var showConfig = JSON.parse(record.showConfig);
        return showConfig.bigCover == undefined ? true : showConfig.bigCover;
      } else {
        return true;
      }
    },
    eventChange: function eventChange(v) {
      this.queryParam.eventId = v.target.value;
      this.getList();
    },
    onEventCategory: function onEventCategory(v) {
      this.queryParam.eventCategory = v;
      this.getList();
    },
    getDictValue: function getDictValue(text) {
      return text ? filterMultiDictText(this.dictOptions["eventCategory"], text) : "";
    },
    toDetail: function toDetail(item) {
      var route = this.$router.resolve({
        path: "/event/detail",
        query: {
          id: item.id
        }
      });
      window.open(route.href, "_blank");
    }
  }
};